import {HomeEndPoints} from 'main/factories/usecases/endpoints';

export const getHomeEndpoint = (useV3 = false): HomeEndPoints =>
	useV3 ? HomeEndPoints.homeV3 : HomeEndPoints.home;
